<ng-container *transloco="let t; read: 'blog-v260'">
  <h1>{{ t("title") }}</h1>
  <section class="article">
    <article>
      <h2>{{ t("zoom-title") }}</h2>
      <div class="text">
        <p>{{ t("zoom-intro") }}</p>
        <img
          src="assets/v260-zoom01.png"
          alt="Zoom-Menü im Clip-Editor"
          style="width: 480px"
        />
      </div>
    </article>
    <article>
      <h2>{{ t("image-style-title") }}</h2>
      <div class="text">
        <p>{{ t("image-style-intro") }}</p>
        <img
          src="assets/v260-image-style01.png"
          alt="Stil-Einstellungen für Bilder"
          style="width: 400px"
        />
      </div>
    </article>
    <article>
      <h2>{{ t("change-resolution-title") }}</h2>
      <div class="text">
        <p>{{ t("change-resolution-intro") }}</p>
      </div>
    </article>
    <article>
      <h2>{{ t("show-fast-motion-title") }}</h2>
      <div class="text">
        <p>{{ t("show-fast-motion-intro") }}</p>
        <img
          src="assets/show-fast-motion-01.png"
          alt="Stil-Einstellungen für Zeitraffer"
          style="width: 400px"
        />
        <img
          src="assets/show-fast-motion-02.png"
          alt="Anzeige der Zeitraffer im Film"
          style="width: 400px"
        />
      </div>
    </article>
  </section>
</ng-container>
